import React from 'react'
import DocRowContainer from '../../../cmn/DocRowContainer'
import FormROValue from '../../../../library/form/components/FormROValue1';
import SarasTrans from "../../../../library/notifications/SarasTrans";

const RolePrivilage = (props) => {
    const { formObject, rowKey, rowValueKey } = props;
    
    if( rowValueKey === "docType")
        return(null);
        
    return (
        <li className="uiTick">
            <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: rowValueKey }}
                    className="uiInline"
            />
        </li>
    )
}

const RolePrivilegeRow = (props) => {
    const { formObject, rowKey, viewData } = props;
    return (
        <DocRowContainer formObject={formObject} rowKey={rowKey} containerClass="uiSpacerR2" >
        <div style={{"minHeight":"150px"}} className="uiBoxBlue">
            <div>
                <span className="uiSpacerR2"><SarasTrans value="Document" /></span>
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "docType" }}
                    className="uiHeaderElement"
                />
            </div>
            <div>
                <ul className="uiBulletList">
                    {
                        Object.values(viewData.rowValues).map((row, index) => (
                            <RolePrivilage formObject={formObject} rowKey={rowKey} rowValueKey={row.key} key={index} />
                        ))
                    }
                </ul>
            </div>
        </div>
        </DocRowContainer>
    )
}

export default RolePrivilegeRow